// extracted by mini-css-extract-plugin
export var aggregationCell = "_5x-n";
export var aggregationRow = "_5x-m";
export var borderlessSpinnerContainer = "_5x-3";
export var cardLayout = "_5x-6";
export var cardLayoutNoFooter = "_5x-9";
export var cardLayoutPageControl = "_5x-8";
export var closeIcon = "_5x-f";
export var columnHeaderSurface = "_5x-b";
export var columnHeaderSurfaceDragOverlay = "_5x-v";
export var columnHeaderSurfaceResizing = "_5x-s";
export var contextMenuAnchor = "_5x-1";
export var draggableColumnHeader = "_5x-t";
export var draggableColumnHeaderOverlay = "_5x-u";
export var expandIcon = "_5x-g";
export var expanded = "_5x-h";
export var filterDropdown = "_5x-i";
export var filterDropdownDivider = "_5x-d";
export var filterDropdownHeader = "_5x-l";
export var filterDropdownItem = "_5x-k";
export var filterDropdownModal = "_5x-j _5x-i";
export var filterItem = "_5x-c";
export var normalCellWithAdjustableBorder = "_5x-e";
export var pinButtonContainer = "_5x-o";
export var pinIcon = "_5x-p";
export var pinIconActive = "_5x-q";
export var spinner = "_5x-0";
export var spinnerContainer = "_5x-2";
export var tableContainer = "_5x-4";
export var tableContentDraggingColumns = "_5x-a";
export var tableContentInner = "_5x-7";
export var tableContentWrapper = "_5x-5";
export var viewButtonContainer = "_5x-r";